import { useSearchspringRecommendContext } from "@app/scripts/providers/searchspring"
import { useEffect, useState } from "react"
import { excludeProducts } from "@app/scripts/lib/excluded-products"

export type SearchspringRecommendItem<T> = {
  id: string
  attributes: T
  brand: string
  msrp: number
  name: string
  price: number
  sku: string
  uid: string
  thumbnailImageUrl?: string
  imageUrl?: string
  url: string
}

/** Just a here for testing.  */
const imageUrl = ""

export function useSearchspringRecommendResults<
  attributes,
>(): SearchspringRecommendItem<attributes>[] {
  const [results, setResult] = useState<
    SearchspringRecommendItem<attributes>[]
  >([])
  const { response } = useSearchspringRecommendContext()

  const handleAttributes = (attributes: attributes): attributes => {
    const data = Object.keys(attributes).reduce(
      (acc: { [key: string]: string }, key) => {
        try {
          const parse = JSON.parse(attributes[key])
          acc[key] = parse
          return acc
        } catch {
          acc[key] = attributes[key]
          return acc
        }
      },
      {}
    ) as attributes

    return data
  }

  useEffect(() => {
    if (!response || !response?.length) return
    const _result = response
      .map(({ results }) =>
        results.map((result) => ({
          id: result.id,
          attributes: handleAttributes(result.attributes as attributes),
          imageUrl: result?.mappings.core.imageUrl ?? imageUrl,
          ...result.mappings.core,
        }))
      )
      .flat() as SearchspringRecommendItem<attributes>[]
    setResult(excludeProducts(_result))
  }, [response])

  return results
}
